export const crypto = typeof window !== 'undefined'
    ? window.crypto || window.msCrypto
    : null;
export const subtle = crypto?.subtle || crypto?.webkitSubtle;
export const isSupported = () => !!crypto;
export const getRandomValues = (typedArray) => crypto.getRandomValues(typedArray);
